import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <h1 className="text-9xl md:text-[12rem] font-black text-gray-100 select-none pointer-events-none absolute top-1/2 -translate-y-1/2">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-semibold text-gray-900">页面走丢了</h2>
        <p className="mt-2 text-base text-gray-400">站娘找了一圈，也没发现这个页面...</p>
        <Link to="/" className="btn-primary mt-6 inline-block">
          返回首页
        </Link>
      </div>
    </div>
  );
}